<template>
	<div class="rectangle-box-container">
		<RectangleBox :border="border" />
		<div class="rectangle-box-decoration">
			<GoldenCorner v-if="!cornerTopLeftDisable" top left />
			<GoldenCorner v-if="!cornerTopRightDisable" top right />
			<GoldenCorner v-if="!cornerBottomLeftDisable" bottom left />
			<GoldenCorner v-if="!cornerBottomRightDisable" bottom right />
		</div>
	</div>
</template>

<script lang="ts" setup>
import GoldenCorner from "@/components/SVG/GoldenCorner.vue";
import RectangleBox from "@/components/SVG/RectangleBox.vue";
import type { Tuple } from "@/types";

interface Props {
	border?: Tuple<number, 4> | null;
	cornerTopLeftDisable?: boolean;
	cornerTopRightDisable?: boolean;
	cornerBottomLeftDisable?: boolean;
	cornerBottomRightDisable?: boolean;
}

const {
	border = null,
	cornerTopLeftDisable = false,
	cornerTopRightDisable = false,
	cornerBottomLeftDisable = false,
	cornerBottomRightDisable = false,
} = defineProps<Props>();
</script>

<style lang="scss" scoped>
// NOTE: The key idea behind using such boxes is that
// a box is created, which is RELATIVELY positioned and resized, and the CONTENT is a subsequent div with this component,
// which must be positioned absolutely

.rectangle-box {
	&-container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	&-decoration {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;

		:deep(.golden-corner) {
			display: flex;
			width: 1rem;
			height: 1rem;
		}

		:deep(.golden-corner--top-left) {
			position: absolute;
			top: 0;
			left: 0;
		}

		:deep(.golden-corner--top-right) {
			position: absolute;
			top: 0;
			right: 0;
		}

		:deep(.golden-corner--bottom-left) {
			position: absolute;
			bottom: 0;
			left: 0;
		}

		:deep(.golden-corner--bottom-right) {
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
}

:deep(.rectangle-box) {
	box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.6);
	width: 100%;
	height: 100%;
}
</style>
